export const TABLE_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50]
/** Union of all row counts used by any paginated DataTable (for PATCH /users). */
export const ALL_TABLE_ROWS_SAVE_OPTIONS = [1, 2, 5, 10, 20, 25, 50, 100]
export const MANUFACTURERS_TABLE_ROWS_OPTIONS = [1, 5, 10, 25, 50]
export const REPORTS_TABLE_ROWS_OPTIONS = [2, 5, 10]
export const DEFAULT_TABLE_ROWS = 10

export const normalizeTableRows = (
  value,
  allowedOptions = TABLE_ROWS_PER_PAGE_OPTIONS
) => {
  const parsed = parseInt(value, 10)
  if (!Number.isFinite(parsed)) {
    return allowedOptions.includes(DEFAULT_TABLE_ROWS)
      ? DEFAULT_TABLE_ROWS
      : allowedOptions[0]
  }

  if (allowedOptions.includes(parsed)) {
    return parsed
  }

  const sorted = [...allowedOptions].sort((a, b) => a - b)
  const lowerOrEqual = sorted.filter((option) => option <= parsed)
  if (lowerOrEqual.length > 0) {
    return lowerOrEqual[lowerOrEqual.length - 1]
  }

  return sorted[0]
}

export const getInitialPaginationState = (user, extra = {}) => {
  const { allowedRowsOptions = TABLE_ROWS_PER_PAGE_OPTIONS, ...rest } = extra
  return {
    first: 0,
    page: 0,
    rows: normalizeTableRows(user?.tableRowsPerPage, allowedRowsOptions),
    ...rest,
  }
}
